import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { getRangeColor } from '@/lib/range.ts'
import type {
  GetClientsWidgetDataViewModel,
  GetPerformanceFinanciereDashboardViewModel,
  GetRepartitionClientsParAgenceViewModel,
  GetSuiviCommandeViewModel,
  RangeColor,
  CommercialActivityStatsViewModel,
  RepartitionSuiviCommandeViewModel,
  ValuePercentageViewModel,
} from '@/lib/types'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

type FieldResult = {
  label: string
  value: number
  percentage?: number
  color?: string
}

type DataWithPercentage =
  | GetClientsWidgetDataViewModel
  | GetSuiviCommandeViewModel
  | GetRepartitionClientsParAgenceViewModel
  | RepartitionSuiviCommandeViewModel
  | GetPerformanceFinanciereDashboardViewModel
  | CommercialActivityStatsViewModel

export function generateField<
  T extends DataWithPercentage,
  Settings extends Record<string, RangeColor[]>,
>(
  settings: Settings | false,
  data: T,
  label: string,
  fieldName: keyof T,
  suffix?: string | null,
  rangeName?: keyof Settings,
): FieldResult {
  const fieldData = data[fieldName]
  const isValuePercentage = typeof fieldData === 'object'

  const result: FieldResult = {
    label: suffix ? `${label} <span class="text-muted-foreground">(${suffix})</span>` : label,
    value: isValuePercentage
      ? (fieldData as ValuePercentageViewModel).value
      : (fieldData as number),
  }

  if (isValuePercentage) {
    const percentage = (fieldData as ValuePercentageViewModel).percentage
    result.percentage = percentage

    if (rangeName && settings) {
      const color = getRangeColor(settings[rangeName], percentage.toString())
      if (color) result.color = color
    }
  }

  return result
}

export function formatDate(date: string): string {
  return new Date(date).toLocaleDateString('fr-FR')
}
